import ProductName from '@web/components/ProductName'

type Item = {
  title: string
  body: React.ReactNode
}

const items: Item[] = [
  {
    title: 'Make effective use of ratepayer money.',
    body: (
      <>
        Cut staff time on LIM and consent hazard work by 50 to 90%, reduce external hazards
        consulting spend on screening-level work by 50 to 70%, and avoid the 0.5 to 2 FTE growth in
        planning headcount that NPS-NH and the new LIM regulations would otherwise require. Most
        councils see a 2 to 8 month payback on the annual licence.
      </>
    ),
  },
  {
    title: "Provide a faster service and protect the council's reputation.",
    body: (
      <>
        Shorten LIM turnaround from days to hours, eliminate the consent-processing bottleneck that
        the new NPS-NH classification work has created, and avoid the kind of public-confidence
        damage that surfaces when LIM backlogs hit the media.
      </>
    ),
  },
  {
    title: 'Stay compliant with in-force regulation and avoid downstream liability.',
    body: (
      <>
        Meet the LGOIMA section 44B obligations live since October 2025, satisfy NPS-NH Policy 5
        (best available information) on every consent decision with a full audit trail, and reduce
        the personal and council-level exposure that follows from the Crown&apos;s withdrawal from
        post-event buyouts.
      </>
    ),
  },
]

const ValueAdds = () => {
  return (
    <section className="bg-white py-16 sm:py-12">
      <div className="space-y-6 mx-auto max-w-5xl px-6 lg:px-8">
        <div className="space-y-2">
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-blue">
            What it delivers
          </span>
          <h2 className="text-2xl font-light text-brand-navy m-0">
            Implementing <ProductName /> enables a council to:
          </h2>
        </div>

        <ol className="grid gap-6 md:grid-cols-3 m-0 p-0 list-none">
          {items.map((item, idx) => (
            <li
              key={item.title}
              className="border-0 border-l-4 border-solid border-brand-blue pl-5 space-y-2"
            >
              <span className="block text-xs font-semibold tracking-widest text-brand-blue tabular-nums">
                {String(idx + 1).padStart(2, '0')}
              </span>
              <h3 className="text-base font-semibold text-brand-navy m-0">{item.title}</h3>
              <p className="text-sm text-brand-navy/85 leading-relaxed m-0">{item.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default ValueAdds
